import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'forgot-password', loadComponent: () => import('./Modules/user/components/auth/recovery/recovery.component').then(m => m.RecoveryComponent) },
  { path: 'Admin/Reset-Password', loadComponent: () => import('./Modules/user/components/auth/recovery/recovery.component').then(m => m.RecoveryComponent) },
  {
    path: 'Admin', // Load Admin module when URL is /Admin
    // loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    loadChildren: () =>
      import('./Modules/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '', // Load User module when URL is empty or /
    loadChildren: () =>
      import('./Modules/user/user.module').then((m) => m.UserModule),
  },
  { path: 'ADMIN', redirectTo: 'Admin' },
  { path: 'admin', redirectTo: 'Admin' },
  { path: '**', redirectTo: '' }, // Redirect any unknown route to UserModule
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'top', // Scrolls to top on navigation
  anchorScrolling: 'enabled' // Enables anchor scrolling
};

@NgModule({
  imports: [RouterModule.forRoot(routes,routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
